import React from 'react';
import { useState } from 'react';

import { SettingsCoordinator } from '~settings-coordinator/SettingsCoordinator';
import { RemoteRefreshAgents } from '~src/extractRefresh/resources/RemoteRefreshAgents';
import {
  BridgeSiteSettings,
  BridgeSiteSettingsProps,
  SiteBridgeSettingsForSiteAdminProps
} from '~src/settings/general-settings/components/bridge-settings/BridgeSiteSettings';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { EdgePool } from '~src/ts/resources/EdgePool';
import { IGetEdgePoolsResult } from '~src/ts/ServerApi/requests/GetEdgePoolsRequest';
import { IRemoteAgentConnectionStatus } from '~src/ts/ServerApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';

import { EdgePoolsPayload } from '../sections/bridge/types/EdgePoolsPayload';

const initialRemoteAgentConnectionStatuses: IRemoteAgentConnectionStatus[] = [];
const initialEdgePools: EdgePoolsPayload = {
  userDefinedPools: {},
  defaultPoolAgents: {},
  unassignedAgents: {},
  blockedDomains: {},
  siteId: ''
};

/**
 * Creates a settings coordinator with the site bridge settings
 */
export function BridgeSiteSettingsCoordinator(props: SiteBridgeSettingsForSiteAdminProps) {
  const [remoteAgentConnectionStatuses, setRemoteAgentConnectionStatuses] = useState(initialRemoteAgentConnectionStatuses);
  const [edgePools, setEdgePools] = useState(initialEdgePools);
  const [hasLoadedEdgePools, setHasLoadedEdgePools] = useState(false);

  React.useEffect(() => {
    RemoteRefreshAgents.getSiteRemoteAgentsConnectionStatus()
      .then((result: IRemoteAgentConnectionStatus[]) => {
        setRemoteAgentConnectionStatuses(result);
      });
  }, []);

  React.useEffect(() => {
    FeatureFlags.edgeMultiPoolEnabled && EdgePool.getPools({ siteId: props.settings.id })
      .then((result: IGetEdgePoolsResult) => {
        if (result.success) {
          setEdgePools(result.success);
          setHasLoadedEdgePools(true);
        }
        if (result.error) {
          // TODO - ndepass 9/20/21 - Story 1297102: [BridgeSiteSettings] Create Multi-Pool table
        }
      });
  }, [props.settings.id]);

  const refreshEdgePools = React.useCallback(() => {
    FeatureFlags.edgeMultiPoolEnabled && EdgePool.getPools({ siteId: props.settings.id })
      .then((result: IGetEdgePoolsResult) => {
        if (result.success) {
          setEdgePools(result.success);
        }
        if (result.error) {
          // TODO - ndepass 9/20/21 - Story 1297102: [BridgeSiteSettings] Create Multi-Pool table
        }
      });
  }, [props.settings.id]);

  const newProps: BridgeSiteSettingsProps = {
    settings: props.settings,
    connectionStatuses: remoteAgentConnectionStatuses,
    edgePools: edgePools,
    refreshEdgePools,
    hasLoadedEdgePools
  };

  return (
    <SettingsCoordinator>
      <BridgeSiteSettings {...newProps} />
    </SettingsCoordinator>
  );
}
